/**
 * Iterates over an array of blog post metadata and returns a unique list of tags.
 * @param posts - Array of blog post metadata
 * @returns Array of unique tags
 */
export const getAllTags = (posts: BlogPostMetadata[]) => {
	const tags = new Set<string>();

	for (const post of posts) {
		if (post.tags) {
			post.tags.forEach((tag) => tags.add(tag));
		}
	}

	return Array.from(tags).sort();
};
